export default "__VITE_ASSET__CnLrmREI__"